import CDNImage from '@/components/ui/CDNImage';
import { Post } from '@/graphql/generated/graphql';
import Wysiwyg from '@/wp-pages/components/dom-parser';

const PostItem = ({ post }: { post: Post }) => {
  const featuredImage = post?.featuredImage?.node
    ? post.featuredImage.node
    : null;

  return (
    <a
      href={`${process.env.KIA_STORY_URL}/${post.slug}`}
      className="group flex flex-col w-full h-full shadow-md shadow-black/6 no-underline"
    >
      <div className="w-full relative aspect-[4/3] overflow-hidden">
        {featuredImage && (
          <CDNImage
            src={featuredImage.sourceUrl || ''}
            alt={featuredImage.altText || ''}
            width={featuredImage.mediaDetails?.width || 0}
            height={featuredImage.mediaDetails?.height || 0}
            sizes="(max-width: 1024px) 100vw, 570px"
            srcSet={featuredImage.srcSet || ''}
            className="w-full h-full object-cover group-hover:scale-[1.025] transition-all duration-500"
          />
        )}
      </div>
      <div className={`editor-card flex flex-col p-4 lg:p-6`}>
        <h3 className="group-hover:underline underline-offset-2">
          {post.title}
        </h3>
        <div className="font-inherit text-sm [&_samp]:font-inherit line-clamp-3">
          <Wysiwyg stripAnchors>
            {post.excerpt
              ? post.excerpt
              : post.content
                ? `${post.content.slice(0, 300)}`
                : null}
          </Wysiwyg>
        </div>
      </div>
    </a>
  );
};

export default PostItem;
